import apiClient from './api.service'
import { API_ENDPOINTS } from '@/config/api.config'

class AuthService {
  /**
   * Login user with email and password
   * @param {string} email - User email
   * @param {string} password - User password
   * @returns {Promise} API response with tokens
   */
  async login(email, password) {
    const response = await apiClient.post(API_ENDPOINTS.LOGIN, {
      email,
      password,
    })
    
    if (response.data.access) {
      localStorage.setItem('access_token', response.data.access)
      localStorage.setItem('refresh_token', response.data.refresh)
    }
    
    return response.data
  }

  /**
   * Logout user and clear tokens
   */
  logout() {
    localStorage.removeItem('access_token')
    localStorage.removeItem('refresh_token')
  }

  /**
   * Refresh access token
   * @param {string} refreshToken - Refresh token
   * @returns {Promise} New access token
   */
  async refreshToken(refreshToken) {
    const response = await apiClient.post(API_ENDPOINTS.REFRESH, {
      refresh: refreshToken,
    })
    
    if (response.data.access) {
      localStorage.setItem('access_token', response.data.access)
    }
    
    return response.data
  }

  /**
   * Verify token
   * @param {string} token - Token to verify
   * @returns {Promise} Verification response
   */
  async verifyToken(token) {
    const response = await apiClient.post(API_ENDPOINTS.VERIFY, {
      token,
    })
    return response.data
  }

  /**
   * Request password reset
   * @param {string} email - User email
   * @returns {Promise} API response
   */
  async resetPassword(email) {
    const response = await apiClient.post(API_ENDPOINTS.RESET_PASSWORD, {
      email,
    })
    return response.data
  }

  /**
   * Get current access token
   * @returns {string|null} Access token
   */
  getAccessToken() {
    return localStorage.getItem('access_token')
  }

  /**
   * Get current refresh token
   * @returns {string|null} Refresh token
   */
  getRefreshToken() {
    return localStorage.getItem('refresh_token')
  }

  /**
   * Check if user is authenticated
   * @returns {boolean} Authentication status
   */
  isAuthenticated() {
    return !!this.getAccessToken()
  }
}

export default new AuthService()

